<template>
  <div class="edit-community-page">
    <div class="head-wrap flex-rowl">
      <div class="icon">
        <img src="../../../assets/images/business-title-icon.png" alt="" />
      </div>
      <div class="head-content">
        <h1>新增居委单位</h1>
        <p>业务区域管理</p>
      </div>
    </div>

    <!-- 表单 -->
    <div class="from-wrap">
      <div class="from-item mb_85">
        <div class="label"><span class="requird"></span>居委单位名称：</div>
        <div class="input-box">
          <input
            type="text"
            placeholder="请输入居委单位名称，30个字符内"
            maxlength="30"
            v-model="params.nbname"
          />
        </div>
      </div>
      <div class="from-item mb_100">
        <div class="label"><span class="requird"></span>关联所属街道：</div>

        <div class="label_wrap" v-if="selectstreetList.length > 0">
          <div
            class="spe_info_item label_item flex-rowl"
            v-for="(item, index) in selectstreetList"
            :key="index"
          >
            <div class="txt">[ 已选街道名称 ]：</div>
            <div class="box flex-rowl">{{ item.streetname }}</div>
            <div class="operation_wrap flex-rowc">
              <div
                class="cancel_box flex-rowc"
                @click="handleDelSelectLabel(item, 'streetList')"
              >
                <van-icon name="delete-o" />
              </div>
            </div>
          </div>
        </div>
        <div
          class="add_btn flex-rowc"
          @click="handleShowRadio('streetList', 'isShowStreet')"
        >
          <van-icon name="plus" /> 设置关联所属街道
        </div>
      </div>

      <div class="from-item-address mb_75">
        <div class="tit">所属市区</div>
        <div class="txt">
          <p>省/直辖市：上海</p>
          <p>城市：上海</p>
        </div>
      </div>
      <div class="from-item mb_100">
        <div class="label"><span class="requird"></span>区域：</div>
        <div
          class="select-box flex-rowc"
          :class="{ 'has-value': areastr }"
          @click="handleShow('isShow')"
        >
          {{ areastr ? areastr : "选择区域" }}
        </div>
      </div>
      <div class="from-item form-item-radio">
        <div class="label"><span class="requird"></span> 居委单位状态？</div>
        <div class="radio-box flex-rowc">
          <div
            class="radio-item flex-rowl"
            :class="{ active: params.nbstate === '1' }"
            @click="handleRadio('1')"
          >
            启用
          </div>
          <div
            class="radio-item flex-rowl"
            :class="{ active: params.nbstate === '0' }"
            @click="handleRadio('0')"
          >
            停用
          </div>
        </div>
      </div>
    </div>

    <!-- 底部 -->
    <div class="fixed-btm flex-rowc">
      <div class="return flex-rowc" @click="handleBack">返回</div>
      <div
        class="add-btn flex-rowc"
        :class="{ disanled: isSubmitting }"
        @click="handleSubmit"
      >
        确认·保存
      </div>
    </div>

    <!-- 选择区域 -->
    <van-popup v-model="isShow" position="bottom" :style="{ height: '45%' }"
      ><van-picker
        title="选择区域"
        show-toolbar
        :columns="areaList"
        @confirm="onConfirm"
        @cancel="onCancel('isShow')"
        value-key="addrname"
    /></van-popup>

    <!-- 关联所属街道 -->
    <van-overlay :show="isShowStreet" z-index="10001" :lock-scroll="false">
      <div class="custom_popup">
        <div class="custom_popup_head flex-between">
          <div class="tit flex-rowl">
            请选择关联所属街道 <span>（单选）</span>
          </div>
          <span class="close" @click="handleCloseRadio('isShowStreet')"
            ><van-icon name="cross"
          /></span>
        </div>
        <div
          class="custom_popup_body"
          ref="customPopupBody"
          @scroll="handleScroll"
        >
          <div
            class="custom_popup_body_list flex-rowl"
            v-if="streetList.length > 0 && !isLoading"
          >
            <div
              class="custom_popup_body_item flex-rowl"
              v-for="(item, index) in streetList"
              :key="index"
              @click="handleItem(item, 'streetList', 'single')"
            >
              {{ item.streetname }}
              <span class="active" v-if="item.active"></span>
            </div>
          </div>
          <div class="hasMore flex-rowc" v-if="hasMore && streetList.length == totalPage">暂无更多数据...</div>
          <!-- 无数据 -->
          <div
            class="custom_date flex-colc"
            v-if="streetList.length == 0 && !isLoading"
          >
            <div class="custom_date_img">
              <img
                src="../../../assets/images/no-date.png"
                alt=""
                class="custom_date_img"
              />
            </div>
            <div class="custom_date_btn flex-rowc" @click="handleGo">
              添加关联所属街道
            </div>
          </div>
        </div>
        <div class="custom_popup_footer flex-between">
          <div
            class="return flex-rowc"
            @click="handleCloseRadio('isShowStreet')"
          >
            <van-icon name="arrow-left" />返回
          </div>
          <div
            class="btn flex-rowc"
            @click="handleSubmitLabel('streetList', 'isShowStreet', 'single')"
          >
            确认
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { getArea } from "../../../api/public";
import { getStreetList } from "../../../api/api";
import {
  addCommunity,
  editCommunity,
  getCommunityDetail,
} from "../../../api/api";
export default {
  name: "EditCommunityManagement",
  data() {
    return {
      // 参数
      params: {
        id: "",
        nbname: "",
        streetid: "", // 关联街道id
        province: 24, // 上海
        city: 456, // 上海市
        area: "",
        nbstate: "", // 居委状态 =1=启用|0=停用|
      },
      streetList: [], // 街道列表
      streetParams: {
        pageindex: 1,
        pagesize: 35,
        keyword: "",
        streetstate: 1, // 街道状态 =1=启用|0=停用|
      },
      totalPage: 1, // 总页数
      isLoading: true, // 是否正在加载
      hasMore: false, // 是否还有更多数据
      isShowStreet: false, // 显示街道列表
      // 选中的街道
      selectstreetList: [],
      isLoadingMore: false, // 新增加载状态锁

      areastr: "", // 区域名称
      areaList: [], // 区域列表
      isShow: false,

      isSubmitting: false, // 提交中标记
    };
  },
  created() {
    this.getAreaList();
    this.getStreetList();
    if (this.$route.query.id) {
      this.params.id = this.$route.query.id;
      this.getCommunityDetail();
    }
  },
  methods: {
    // 获取区域列表
    async getAreaList() {
      const res = await getArea(this.params.city);
      this.areaList = res;
    },

    // 获取街道列表
    async getStreetList() {
      try {
        const res = await getStreetList(this.streetParams);
        if (res.list) {
          this.streetList = this.streetList.concat(res.list);
          this.totalPage = res.total;
        }
      } catch (error) {
        console.error("获取街道列表失败", error);
      } finally {
        // 等待 800 毫秒后关闭加载提示
        await new Promise((resolve) => setTimeout(resolve, 500));
        this.isLoading = false;
      }
    },

    // 获取街道详情
    async getCommunityDetail() {
      const res = await getCommunityDetail(this.params.id);
      try {
        this.params.nbname = res.nbname;
        this.params.streetid = res.streetid;
        this.params.area = res.area;
        this.areastr = res.areastr;
        this.params.nbstate = res.nbstate;
        this.selectstreetList = [
          { id: res.streetid, streetname: res.streetidstr },
        ];
      } catch (error) {
        console.error("获取街道详情失败:", error);
        this.$toast.fail("获取街道详情失败，请稍后重试");
      }
    },

    // 触发单选框
    handleRadio(item) {
      this.params.nbstate = item;
    },

    // 显示弹窗
    handleShow(type) {
      this[type] = true;
    },
    // 确认区域
    onConfirm(e) {
      this.params.area = e.addrid;
      this.areastr = e.addrname;
      this.onCancel("isShow");
    },
    // 取消
    onCancel(type) {
      this[type] = false;
    },

    /**
     * 单选操作start
     */
    // 1、显示弹窗
    handleShowRadio(list, name) {
      const targetList = this[list];
      const selectList = this[`select${list}`];
      // 调用新方法设置 active 状态
      this.setActiveStatus(targetList, selectList);
      this[name] = true;
    },
    // 2、关闭弹窗
    handleCloseRadio(name) {
      this[name] = false;
    },
    // 3、选中标签
    handleItem(item, list, type) {
      const targetList = this[list];
      if (!Array.isArray(targetList)) {
        console.error("传入的 list 不是有效的数组");
        return;
      }
      if (type === "single") {
        targetList.forEach((listItem) => {
          this.$set(listItem, "active", listItem.id === item.id);
        });
      } else if (type === "multiple") {
        const targetIndex = targetList.findIndex(
          (listItem) => listItem.id === item.id
        );
        if (targetIndex !== -1) {
          const targetItem = targetList[targetIndex];
          this.$set(targetItem, "active", !targetItem.active);
        }
      }
    },
    // 4、确认选中的标签
    handleSubmitLabel(list, name, type) {
      const targetList = this[list];
      const selectList = this[`select${list}`];
      // 过滤出 targetList 中 active 为 true 的元素
      const selectedItems = targetList.filter((item) => item.active);
      if (type === "single") {
        // 清空原列表，添加单个选中项
        selectList.splice(0, selectList.length, ...selectedItems);
      } else if (type === "multiple") {
        // 避免添加重复项
        const newItems = selectedItems.filter(
          (item) =>
            !selectList.some((existingItem) => existingItem.id === item.id)
        );
        selectList.push(...newItems);
      }
      // 确保 Vue 能检测到 selectList 的变化
      this.$set(this, `select${list}`, selectList);
      this[name] = false;
    },
    // 5、删除选中的标签
    handleDelSelectLabel(item, list) {
      const selectList = this[`select${list}`];
      const index = selectList.findIndex((listItem) => listItem.id === item.id);
      if (index !== -1) {
        selectList.splice(index, 1);
        this.$set(this, `select${list}`, selectList);
      }
    },
    // 抽离出来的设置 active 状态的方法
    setActiveStatus(targetList, selectList) {
      if (selectList.length > 0) {
        const selectedIds = selectList.map((item) => item.id);
        targetList.forEach((item) => {
          // 使用 this.$set 确保 active 属性具有响应式
          this.$set(item, "active", selectedIds.includes(item.id));
        });
      } else {
        // 如果没有选中的街道，将所有项的 active 设为 false
        targetList.forEach((item) => {
          this.$set(item, "active", false);
        });
      }
    },
    // 处理滚动事件
    handleScroll() {
      const { scrollTop, scrollHeight, clientHeight } =
        this.$refs.customPopupBody;
      let { streetList, totalPage, isLoadingMore } = this;
      if (isLoadingMore || streetList.length >= totalPage) return;
      // 当滚动到底部 20px 范围内时触发加载
      if (scrollTop + clientHeight >= scrollHeight - 20) {
        this.hasMore = true;
        this.streetParams.pageindex++;
        this.isLoadingMore = true; // 开始加载，设置锁
        this.getStreetList().finally(() => {
          // 调用新方法设置 active 状态
          this.setActiveStatus(this.streetList, this.selectstreetList);
          this.isLoadingMore = false; // 加载完成，释放锁
        });
      }
    },
    /**
     * 单选操作end
     */

    // 返回上一页
    handleBack() {
      this.$router.back();
    },
    handleGo() {
      this.$router.push({ name: "EditStreetManagement" });
    },

    // 提交
    async handleSubmit() {
      let { nbname, area, nbstate } = this.params;
      let { selectstreetList } = this;
      if (!nbname) {
        this.$toast("请输入街道名称");
        return;
      }
      if (selectstreetList.length == 0) {
        this.$toast("请选择街道");
        return;
      }
      if (!area) {
        this.$toast("请选择区域");
        return;
      }
      if (!nbstate) {
        this.$toast("请选择居委状态");
        return;
      }

      // 处理街道id
      if (selectstreetList.length > 0) {
        this.params.streetid = selectstreetList
          .map((item) => item.id)
          .join(",");
      }

      // 如果正在提交，直接返回
      if (this.isSubmitting) return;

      // 设置提交中标记
      this.isSubmitting = true;
      // 显示加载中提示
      this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
        duration: 0,
      });
      try {
        let res;
        if (this.params.id) {
          // params.id 存在，调用 editCommunity 接口
          res = await editCommunity(this.params);
        } else {
          // params.id 不存在，调用 addCommunity 接口
          res = await addCommunity(this.params);
        }

        if (res.result == "true") {
          await new Promise((resolve) => setTimeout(resolve, 400));
          this.$toast.success("提交成功");

          await new Promise((resolve) => setTimeout(resolve, 800));
          // 提交成功后返回上一页
          this.$toast.clear();
          this.$router.back();
          // this.isSubmitting = false;
        } else {
          this.$toast.fail(res.message || "提交失败，请稍后重试");
          this.isSubmitting = false;
        }
      } catch (error) {
        console.error("提交出错:", error);
        this.$toast.fail("提交出错，请稍后重试");
        this.isSubmitting = false;
      } finally {
        // // 无论成功或失败，都关闭加载提示并重置提交状态
        // this.$toast.clear();
        // this.isSubmitting = false;
      }
    },
  },
};
</script>

<style scoped lang="less">
.edit-community-page {
  padding-bottom: 380px;
  box-sizing: border-box;
  /deep/.van-popup {
    max-width: 750px;
    margin: auto;
    left: 50%;
    transform: translateX(-50%);
  }
  .head-wrap {
    width: 700px;
    margin: auto;
    padding: 70px 0 98px 58px;
    box-sizing: border-box;
    font-size: 20px;
    color: #333333;
    .icon {
      width: 33px;
      height: 40px;
      margin-right: 24px;
    }
    h1 {
      font-size: 30px;
      margin-bottom: 7px;
    }
  }
  .from-wrap {
    width: 600px;
    margin: auto;
    .from-item {
      .label {
        position: relative;
        font-size: 26px;
        color: #333333;
        padding-left: 12px;
        box-sizing: border-box;
        margin-bottom: 23px;
        .requird {
          width: 15px;
          height: 15px;
          background: url("../../../assets/images/required-icon.png") no-repeat
            center;
          background-size: cover;
          display: inline-block;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: -12px;
        }
      }
      &.form-item-radio {
        .label {
          margin-bottom: 60px;
        }
      }
      .input-box,
      .select-box {
        border-bottom: 1px solid #c3c3c3;
        font-size: 24px;
        height: 52px;
        padding: 0 13px;
        box-sizing: border-box;
        input {
          height: 100%;
          width: 100%;
          background: none;
        }
      }
      .select-box {
        position: relative;
        border-bottom: 1px dashed #c3c3c3;
        padding-right: 20px;
        color: #aaaaaa;
        line-height: 52px;
        &.has-value {
          color: #333333;
        }
        input {
          text-align: center;
        }
        &::after {
          display: inline-block;
          content: "";
          background: url("../../../assets/images/select-icon.png") no-repeat
            center;
          background-size: cover;
          width: 26px;
          height: 30px;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 10px;
        }
      }
      .radio-box {
        font-size: 24px;
        color: #464646;
        .radio-item {
          position: relative;
          cursor: pointer;
          &:last-child {
            margin-left: 99px;
          }
          &::before {
            display: inline-block;
            content: "";
            display: inline-block;
            width: 30px;
            height: 30px;
            background: url("../../../assets/images/radio-icon.png") no-repeat
              center;
            background-size: cover;
            margin-right: 15px;
            opacity: 0.4;
          }
          &.active {
            &::before {
              opacity: 1;
            }
          }
        }
      }
      .label_wrap {
        margin-top: 20px;
        font-size: 24px;
        color: #333333;
        .box {
          flex: 1;
          height: 60px;
          border-bottom: 1px solid #c3c3c3;
          padding: 0 10px;
          box-sizing: border-box;
          // 单行文本隐藏
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .operation_wrap {
          font-size: 30px;
        }
      }
      .add_btn {
        width: 100%;
        height: 60px;
        background: #ffffff;
        border-radius: 10px;
        border: 2px dashed #666666;
        margin: auto;
        font-size: 26px;
        color: #666666;
        margin-top: 60px;
        cursor: pointer;
      }
    }
    .from-item-address {
      color: #333333;
      .tit {
        font-size: 26px;

        font-weight: bold;
        margin-bottom: 59px;
        padding-left: 19px;
        box-sizing: border-box;
        position: relative;
        &::before {
          display: inline-block;
          content: "";
          background: url("../../../assets/images/address-form-icon.png")
            no-repeat center;
          background-size: cover;
          width: 28px;
          height: 35px;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: -20px;
        }
      }
      .txt {
        font-size: 26px;
        padding-left: 13px;
        box-sizing: border-box;
        p {
          &:last-child {
            margin-top: 30px;
          }
        }
      }
    }
    .mb_85 {
      margin-bottom: 85px;
    }
    .mb_75 {
      margin-bottom: 75px;
    }
    .mb_100 {
      margin-bottom: 100px;
    }
    .mb_60 {
      margin-bottom: 60px;
    }
  }
  .fixed-btm {
    position: fixed;
    bottom: 0;
    height: 150px;
    background: #fff;
    z-index: 10;
    align-items: flex-start;
    width: 100%;
    max-width: 750px;
    margin: auto;
    cursor: pointer;
    .return {
      font-size: 24px;
      color: #000000;
      height: 100%;
      width: 150px;
      align-items: flex-start;
      padding-top: 50px;
      box-sizing: border-box;
      margin-right: 30px;
      &::before {
        display: inline-block;
        content: "";
        background: url("../../../assets/images/return-icon.png") no-repeat
          center;
        background-size: cover;
        width: 15px;
        height: 25px;
        margin-right: 8px;
      }
    }
    .add-btn {
      width: 210px;
      height: 50px;
      background: #0031c9;
      border-radius: 25px;
      font-size: 24px;
      color: #fff;
      margin-top: 38px;
      &.disanled {
        background: #d9d9d9;
      }
    }
  }
  .custom_popup {
    height: 70vh;
    width: 100%;
    border-radius: 30px 30px 0 0;
    position: fixed;
    bottom: 0;
    z-index: 999;
    background: #fff;
    max-width: 750px;
    left: 50%;
    transform: translateX(-50%);
    .icon-jujueweituo {
      position: absolute;
      display: inline-block;
      font-size: 56px;
      left: 50%;
      transform: translateX(-50%);
      top: -80px;
      color: #fff;
    }
    .custom_popup_head {
      height: 110px;
      padding: 0 30px;
      box-sizing: border-box;
      .tit {
        font-size: 24px;
        color: #3c3c3c;
        position: relative;
        &::before {
          width: 5px;
          height: 28px;
          background: #ff0042;
          margin-right: 12px;
          display: inline-block;
          content: "";
        }
        span {
          font-size: 18px;
          color: #ff0042;
        }
      }
      .close {
        font-size: 34px;
        color: #3c3c3c;
        cursor: pointer;
      }
    }
    .custom_popup_body {
      height: calc(100% - 270px);
      padding-bottom: 20px;
      box-sizing: border-box;
      margin: 0 0 30px;
      overflow-y: scroll;
      // 隐藏滚动条
      &::-webkit-scrollbar {
        display: none;
      }
      .custom_popup_body_list {
        align-items: flex-start;
        padding: 0 30px;
        flex-wrap: wrap;
        .custom_popup_body_item {
          // display: inline-block;
          border: 2px solid #ececec;
          font-size: 22px;
          color: #3c3c3c;
          border-radius: 30px;
          padding: 0 80px 0 35px;
          box-sizing: border-box;
          height: 60px;
          // line-height: 60px;
          position: relative;
          margin: 0 20px 10px 0;
          cursor: pointer;
          .active {
            display: inline-block;
            width: 31px;
            height: 30px;
            background: url("../../../assets/images/radio_select.png") no-repeat
              center;
            background-size: cover;
            position: absolute;
            right: 10px;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }
      .custom_date {
        height: 80%;
        .custom_date_img {
          width: 166px;
          height: 233px;
        }
        .custom_date_btn {
          width: 330px;
          height: 70px;
          background: #0031c9;
          border-radius: 35px;
          font-size: 26px;
          color: #fff;
          margin-top: 39px;
        }
      }

      .isLoading {
        // height: 40%;
        font-size: 28px;
      }
      .hasMore {
        font-size: 24px;
        padding: 40px 0 50px;
        box-sizing: border-box;
      }
    }
    .custom_popup_footer {
      box-shadow: 0 0 20px 20px rgba(0, 0, 0, 0.05);
      height: 160px;
      box-sizing: border-box;
      align-items: flex-start;
      font-size: 26px;
      cursor: pointer;
      .return {
        flex: 1;
        height: 100px;
      }
      .btn {
        width: 500px;
        height: 100px;
        background: #ff0039;
        color: #fff;
      }
    }
  }
}
</style>